import { render, staticRenderFns } from "./ProgramasLayout.vue?vue&type=template&id=f6d04b4e&scoped=true"
import script from "./ProgramasLayout.vue?vue&type=script&lang=js"
export * from "./ProgramasLayout.vue?vue&type=script&lang=js"
import style0 from "./ProgramasLayout.vue?vue&type=style&index=0&id=f6d04b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d04b4e",
  null
  
)

export default component.exports